export default __webpack_public_path__ + "static/media/image3historia.b6b72048.jpeg";